import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type CardFrontCardInfoFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'id' | 'closed' | 'idBoard' | 'idList'>
);

export const CardFrontCardInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardFrontCardInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idBoard' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idList' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseCardFrontCardInfoFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      CardFrontCardInfoFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseCardFrontCardInfoFragmentResult
  extends Omit<Apollo.UseFragmentResult<CardFrontCardInfoFragment>, 'data'> {
  data?: CardFrontCardInfoFragment;
}

export const useCardFrontCardInfoFragment = ({
  from,
  returnPartialData,
  ...options
}: UseCardFrontCardInfoFragmentOptions): UseCardFrontCardInfoFragmentResult => {
  const result = Apollo.useFragment<CardFrontCardInfoFragment>({
    ...options,
    fragment: CardFrontCardInfoFragmentDoc,
    fragmentName: 'CardFrontCardInfo',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as CardFrontCardInfoFragment };
};
